export default "__VITE_ASSET__8_rvMbTP__"